module.exports = __webpack_public_path__ + "h5/img/admin.644aa5ff.png";